import { X } from '@phosphor-icons/react';

export interface FilterChip {
  key: string;
  label: string;
}

interface ActiveFilterChipsProps {
  chips: FilterChip[];
  onRemove: (key: string) => void;
  onClearAll: () => void;
}

export function ActiveFilterChips({ chips, onRemove, onClearAll }: ActiveFilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      {chips.map((c) => (
        <span
          key={c.key}
          className="inline-flex items-center gap-1 rounded-full bg-sand py-1 pl-3 pr-1 text-sm font-medium text-ink"
        >
          {c.label}
          <button
            type="button"
            onClick={() => onRemove(c.key)}
            aria-label={`Remove filter ${c.label}`}
            className="flex h-5 w-5 items-center justify-center rounded-full transition hover:bg-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clay"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="text-sm font-semibold text-clay hover:underline"
      >
        Clear all
      </button>
    </div>
  );
}
